export const mockD2dSuccessResponse = {
  applicantInfo: {
    'cipher.emailAddress': 'test.test@test.com',
    contact: [{ contactNumber: '1234567890' }],
    address: {
      'cipher.addressLine1': '',
      'cipher.addressLine2': '',
      'cipher.city': '',
      'cipher.state': '',
      'cipher.zipCode': '',
    },
    membershipInfo: {
      memberNumber: '',
      memberSinceDate: '',
      reissueDate: '',
      rewardsNumber: '',
      auMembershipNumber: '',
      alternateCustomerId: '',
    },
    finderNumber: '',
  },
  jointApplication: {
    'cipher.firstName': '',
    'cipher.lastName': '',
    'cipher.middleInitial': '',
    'cipher.emailAddress': '',
    residenceType: '',
    contact: [{}],
    address: {
      'cipher.addressLine1': '',
      'cipher.addressLine2': '',
      'cipher.city': '',
      'cipher.state': '',
      'cipher.zipCode': '',
    },
    membershipInfo: {
      memberNumber: '',
      memberSinceDate: '',
      reissueDate: '',
      rewardsNumber: '',
      auMembershipNumber: '',
      alternateCustomerId: '',
    },
    purchaseAmount: '',
    finderNumber: '',
    initialPurchaseAmount: '',
  },
  merchantInfo: {
    clientCode: 'LOWES',
    productCodeGroupCode: '',
    'cipher.merchantId': '',
    'cipher.storeMid': '',
    uniqueId: '',
    siteCode: '',
    storeNumber: '2999',
    associateId: '12345',
    token: '',
    merchantDeviceId: '',
    termsDocumentId: '',
    merchantName: '',
    productName: '',
    channelId: 'MPOS',
    associateName: '',
    websiteUrl: '',
    merchantDisplayName: '',
    partnerCode: '',
    partnerType: '',
  },
  strategyInfo: {
    promoCode: 'TESTPROMO123',
    specialProcessingCode: '',
    viaCode: '',
    originCode: '',
    trackingCode: '',
    productType: '',
    memberType: '',
    engagementIndex: '',
    acorId: '',
  },
  deliveryMethod: 'EMAIL',
  omniStatus: 'NEW',
  tempPassInfo: null,
  d2dUrl: 'https://daccounts.syf.com/?c=lowes&?d=',
  offers: null,
};

export const mockD2dErrorResponse = {
  code: 400,
  error: 'Invalid D2D  token',
};
